import styled from "styled-components";

export const Stack = styled.div<{
  ["data-size"]?: "default" | "large";
}>`
  > * + * {
    margin-top: var(--spacing-default);
  }
  &[data-size="large"] > * + * {
    margin-top: var(--spacing-large);
  }
`;
export default Stack;
